import React from 'react';

import { OrderTrackingView } from '../../../pages/OrderTracking/OrderTracking1/tracking.view';
import { useOrderTracking } from '../../../pages/OrderTracking/OrderTracking1/useOrderTracking';

/**
 * `/admin-order-tracking`, the admin container.
 *
 * This file used to be 107 lines that were a line-for-line copy of
 * `OrderTracking1.jsx`: the same mutation, the same submit handler, the same
 * step machine, the same two modals and the same body, with `<AdminLayout>`
 * swapped in for `<Layout>`. Converging the two was the point of batch B9.
 *
 * What is left is the only thing that was ever different: the shell, which the
 * view picks from `variant`, and the mutation key, which keeps the admin
 * lookup's React Query cache separate from the buyer's.
 *
 * `App.js` wraps this route in `ProtectedRoute requireAdmin`, unlike the public
 * one. See `OrderTracking1.jsx` for that flag.
 */
export default function AdminOrderTracking() {
  const tracking = useOrderTracking({ mutationKey: 'track-order-admin' });
  return <OrderTrackingView variant="admin" {...tracking} />;
}
